"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = {
    key: 0,
    class: "grid h-screen place-items-center"
};
const _hoisted_2 = { class: "bg-red h-12 grid place-items-center" };
const _hoisted_3 = ["src"];
const _hoisted_4 = /*#__PURE__*/ (0, vue_2.createElementVNode)("h1", { class: "font-bold pt-4 sm:text-5xl text-2xl text-center uppercase" }, "Karbantartás", -1);
const _hoisted_5 = /*#__PURE__*/ (0, vue_2.createElementVNode)("p", { class: "sm:text-2xl p-4 text-center" }, [
    /*#__PURE__*/ (0, vue_2.createTextVNode)(" Rendszerkarbantartás miatt "),
    /*#__PURE__*/ (0, vue_2.createElementVNode)("b", null, "2023.12.29-én 16:00 órától - 2024.01.02. 08:00 óráig"),
    /*#__PURE__*/ (0, vue_2.createElementVNode)("br"),
    /*#__PURE__*/ (0, vue_2.createTextVNode)(" a webáruház nem elérhető. ")
], -1);
const _hoisted_6 = ["href"];
const _hoisted_7 = { class: "grow text-right flex justify-end" };
const _hoisted_8 = ["onClick"];
const vue_3 = require("vue");
const vue_router_1 = require("vue-router");
const BackToTop_vue_1 = __importDefault(require("../components/Layout/BackToTop.vue"));
// import ErrorReportFloatingButton from "../components/Layout/ErrorReportFloatingButton.vue";
const Navbar_vue_1 = __importDefault(require("../components/Layout/Navbar.vue"));
const Toasts_vue_1 = __importDefault(require("../components/Layout/Toasts.vue"));
const Modal_vue_1 = __importDefault(require("../components/Modal.vue"));
const Alert_vue_1 = __importDefault(require("../components/Alert.vue"));
const ServerError_1 = __importDefault(require("../common/error/ServerError"));
const Foot_vue_1 = __importDefault(require("../components/Layout/Foot.vue"));
const securityStore_1 = require("../stores/security/securityStore");
const toastStore_1 = require("../stores/toast/toastStore");
const i18n_1 = require("../common/i18n");
const PermissionEnum_1 = require("../models/permission/PermissionEnum");
const customDesignStore_1 = require("../stores/customDesign/customDesignStore");
const cartsStore_1 = require("../stores/carts/cartsStore");
const fetch_1 = __importDefault(require("../common/utils/fetch"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'App',
    setup(__props) {
        const cartsStore = (0, cartsStore_1.useCartsStore)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const route = (0, vue_router_1.useRoute)();
        const router = (0, vue_router_1.useRouter)();
        const securityStore = (0, securityStore_1.useSecurityStore)();
        const customDesignStore = (0, customDesignStore_1.useCustomDesignStore)();
        const currentUser = (0, vue_3.computed)(() => {
            return securityStore.authenticatedUser;
        });
        const errorMessage = (0, vue_3.ref)("");
        // karbantartas mod
        // TODO ezt jo lenne ugy beepiteni, hogy a konfigbol jojjenek a dolgok
        const displayMaintenanceMessage = (0, vue_3.ref)(false);
        let maintenanceBeginDate = new Date('2023-12-29 16:00');
        let maintenanceEndDate = new Date('2024-01-01 08:00');
        let currentDate = new Date();
        if ((currentDate > maintenanceBeginDate) && (currentDate < maintenanceEndDate)) {
            displayMaintenanceMessage.value = true;
        }
        const acceptableContracts = (0, vue_3.computed)(() => {
            if ("acceptableContracts" in securityStore.payload &&
                Array.isArray(securityStore.payload.acceptableContracts)) {
                return securityStore.payload.acceptableContracts;
            }
            return [];
        });
        const isLoginPage = (0, vue_3.computed)(() => 'app_login' === router.currentRoute.value.name);
        const isRegistrationPage = (0, vue_3.computed)(() => 'registration_page' === router.currentRoute.value.name);
        const acceptingUserIri = (0, vue_3.computed)(() => {
            if (securityStore.authenticatedUser === null) {
                return null;
            }
            return router.resolve({
                name: "admin_users_api",
                params: {
                    id: securityStore.authenticatedUser.id,
                },
            }).fullPath;
        });
        const customerIri = (0, vue_3.computed)(() => {
            if (securityStore.authenticatedUser === null) {
                return null;
            }
            return router.resolve({
                name: "customers_api",
                params: {
                    id: securityStore.authenticatedUser.customer.id,
                },
            }).fullPath;
        });
        const tokenExpirationInEpochSeconds = (0, vue_3.computed)(() => {
            if (securityStore.authenticatedUser === null) {
                return 0;
            }
            return securityStore.authenticatedUser.exp;
        });
        const hasDefaultLayout = (0, vue_3.computed)(() => {
            if (route.meta.hasDefaultLayout === undefined) {
                return true;
            }
            if (typeof route.meta.hasDefaultLayout !== "boolean") {
                return true;
            }
            return (typeof route.meta.hasDefaultLayout === "boolean" &&
                Boolean(route.meta.hasDefaultLayout));
        });
        (0, vue_3.onMounted)(() => {
            if (window.clarity) {
                window.clarity('consentv2', {
                    ad_storage: "granted",
                    analytics_storage: "granted"
                });
            }
        });
        (0, vue_3.onBeforeMount)(async () => {
            try {
                await securityStore.refreshToken(router);
                await securityStore.checkAuth(router);
                await cartsStore.loadCarts(router).catch((error) => {
                    toastStore.addErrorToast(error.toString());
                });
                setInterval(() => {
                    let nowInEpochSeconds = Math.floor(Date.now() / 1000);
                    if (nowInEpochSeconds >
                        tokenExpirationInEpochSeconds.value - 300) {
                        securityStore.refreshToken(router).catch(() => {
                            router.push({ name: "app_login" });
                        });
                    }
                }, 60000, tokenExpirationInEpochSeconds);
                const redirect = router.resolve(route.query.redirect ? `${route.query.redirect}` : route);
                if (redirect.name === route.name) {
                    return;
                }
                if (redirect.name) {
                    await router.replace({ name: redirect.name });
                    return;
                }
            }
            catch (error) {
                if (error instanceof ServerError_1.default &&
                    error.responseData.redirect &&
                    error.responseData.redirect.length &&
                    route.name !== router.resolve(error.responseData.redirect).name) {
                    // checkAuth fails
                    await router.push(error.responseData.redirect);
                }
                if (route.name !== "app_login") {
                    // refreshToken fails or other error
                    await router.push({ name: "app_login" });
                    return;
                }
            }
        });
        (0, vue_3.onUpdated)(async () => {
            let title = route.meta.title
                ? //@ts-expect-error
                    (0, i18n_1.trans)(route.meta.title.toLowerCase(), route.meta.title, "app")
                : "";
            window.document.title = `${title} - MARSO`;
            if (!currentUser.value)
                return;
            // initializeStore meghívása a jogososultság(ok) ellenőrzésére.
            customDesignStore.initializeStore(currentUser.value);
            // Ha aktív az árazási nézet, akkor állítsuk be az előzőleg mentett design-t.
            if (customDesignStore.isCustomPriceViewActive) {
                await customDesignStore.setDesign(currentUser.value);
            }
        });
        const acceptContract = async (acceptableContract) => {
            const payload = {
                contract: acceptableContract["@id"],
                customer: customerIri.value,
                acceptingUser: acceptingUserIri.value,
            };
            try {
                await (0, fetch_1.default)(router.resolve({ name: 'admin_accepted_contracts_api' }).href, { body: JSON.stringify(payload), method: 'POST' });
                securityStore.checkAuth(router);
            }
            catch (error) {
                errorMessage.value = error.toString();
            }
        };
        return (_ctx, _cache) => {
            var _a;
            const _component_router_view = (0, vue_2.resolveComponent)("router-view");
            return (displayMaintenanceMessage.value)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                    (0, vue_2.createElementVNode)("div", null, [
                        (0, vue_2.createElementVNode)("div", _hoisted_2, [
                            (0, vue_2.createElementVNode)("img", {
                                src: require('../images/marso-logo-fekvo.svg'),
                                alt: "Marso logo",
                                class: "inline-block"
                            }, null, 8, _hoisted_3)
                        ]),
                        _hoisted_4,
                        _hoisted_5
                    ])
                ]))
                : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 1 }, [
                    (!(0, vue_2.unref)(hasDefaultLayout))
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_router_view, { key: 0 }))
                        : (0, vue_2.createCommentVNode)("", true),
                    ((0, vue_2.unref)(hasDefaultLayout))
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                            key: 1,
                            class: (0, vue_2.normalizeClass)(["main print-padding-0", {
                                    'pt-[56px]': !(0, vue_2.unref)(isLoginPage),
                                    'foreign-customer': (_a = (0, vue_2.unref)(currentUser)) === null || _a === void 0 ? void 0 : _a.hasPermission((0, vue_2.unref)(PermissionEnum_1.CustomerPermissionEnum).EXPORT_PARTNER)
                                }])
                        }, [
                            ((0, vue_2.unref)(securityStore).authenticated)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Navbar_vue_1.default, {
                                    key: 0,
                                    class: "print:hidden"
                                }))
                                : (0, vue_2.createCommentVNode)("", true),
                            (0, vue_2.createVNode)(_component_router_view, {
                                class: (0, vue_2.normalizeClass)((0, vue_2.unref)(isLoginPage) ? 'app-content-login' : 'app-content')
                            }, {
                                default: (0, vue_2.withCtx)(({ Component }) => [
                                    (0, vue_2.createVNode)(vue_2.Transition, {
                                        name: "fade",
                                        mode: "out-in"
                                    }, {
                                        default: (0, vue_2.withCtx)(() => [
                                            ((0, vue_2.unref)(securityStore).authenticated || (0, vue_2.unref)(isLoginPage) || (0, vue_2.unref)(isRegistrationPage))
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.resolveDynamicComponent)(Component), { key: 0 }))
                                                : (0, vue_2.createCommentVNode)("", true)
                                        ]),
                                        _: 2
                                    }, 1024)
                                ]),
                                _: 1
                            }, 8, ["class"]),
                            (0, vue_2.createVNode)(Foot_vue_1.default, { class: "print:hidden" }),
                            (0, vue_2.createVNode)(Modal_vue_1.default, {
                                closeable: false,
                                isOpen: (0, vue_2.unref)(acceptableContracts) !== undefined &&
                                    (0, vue_2.unref)(acceptableContracts).length > 0,
                                title: (0, vue_2.unref)(i18n_1.trans)('acceptable_contracts', 'Acceptable Contracts', 'app')
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (errorMessage.value.length)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Alert_vue_1.default, {
                                            key: 0,
                                            title: (0, vue_2.unref)(i18n_1.trans)('accept_contract_error', 'Accept Contract Error', 'app'),
                                            message: errorMessage.value
                                        }, null, 8, ["title", "message"]))
                                        : (0, vue_2.createCommentVNode)("", true),
                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(acceptableContracts), (acceptableContract, index) => {
                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                            key: index,
                                            class: "flex py-4"
                                        }, [
                                            (0, vue_2.createElementVNode)("a", {
                                                href: acceptableContract.contentUrl,
                                                class: "underline block",
                                                target: "_blank"
                                            }, (0, vue_2.toDisplayString)(acceptableContract.title), 9, _hoisted_6),
                                            (0, vue_2.createElementVNode)("div", _hoisted_7, [
                                                (0, vue_2.createElementVNode)("button", {
                                                    class: "btn btn-rounded btn-primary",
                                                    onClick: ($event) => (acceptContract(acceptableContract))
                                                }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("accept_contract", "Accept Contract", "app")), 9, _hoisted_8)
                                            ])
                                        ]));
                                    }), 128))
                                ]),
                                _: 1
                            }, 8, ["isOpen", "title"]),
                            (0, vue_2.createVNode)(Toasts_vue_1.default),
                            (0, vue_2.createVNode)(BackToTop_vue_1.default)
                        ], 2))
                        : (0, vue_2.createCommentVNode)("", true)
                ], 64));
        };
    }
});
